export default [
  {
    name: 'Seguimiento de Clientes',
    icon: 'mdi-account-heart',
    path: '/admin/customer-tracking',
    component: () =>
      import(/* webpackChunkName: "admin-customer-tracking" */ './views/CustomerTrackingPage.vue'),
    meta: {
      admin: true,
      allowedRoles: ['consultant', 'admin', 'superadmin'],
      adminToolbar: false,
      adminDrawer: true,
      tooltip: null,
    },
  },
];
